import { Outlet, useOutletContext } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import MyExpensesContent from 'modules/expenses/components/expenses/PageContents/MyExpensesContent'
import { RouteContextParams } from 'modules/expenses/lib/RouteContextParams'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const MyExpensesListPage = () => {
  const { employee } = useCurrentSession()
  const context = useOutletContext<RouteContextParams>()

  useEffect(() => {
    track(trackingEvents.expenses.goToExpenses, { context: 'personal' })
  }, [])

  return (
    <ResponsivePage.Body variant="full">
      <MyExpensesContent>
        <Outlet
          context={{
            ...context,
            employeeIds: [employee?.id],
          }}
        />
      </MyExpensesContent>
    </ResponsivePage.Body>
  )
}

export default MyExpensesListPage
